export const GET_LOCATION_PROJECTS = 'GET_LOCATION_PROJECTS'
export const GET_LOCATION_INCIDENTS = 'GET_LOCATION_INCIDENTS'
export const GET_LOCATION_INFORMATION = 'GET_LOCATION_INFORMATION'
